import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/shared";
import { Overview, Users } from "@/components/admin/AdminCore";
import { Economics, Entitlements } from "@/components/admin/AdminEconomics";
import { Operations, Backups, Reconciliation, Matching } from "@/components/admin/AdminOps";
import AdminEmail from "@/components/admin/AdminEmail";
import AdminGrowth from "@/components/admin/AdminGrowth";
import AdminInventory from "@/components/admin/AdminInventory";
import AdminOutreach from "@/components/admin/AdminOutreach";

const TABS = [["overview", "Overview", Overview], ["inventory", "Job inventory", AdminInventory], ["users", "Users", Users], ["economics", "AI & margin", Economics], ["entitlements", "Entitlements", Entitlements],
  ["operations", "Incidents & ops", Operations], ["email", "Email", AdminEmail], ["backups", "Backups", Backups], ["billing", "Reconciliation", Reconciliation], ["matching", "Matching QA", Matching], ["growth", "Acquisition", AdminGrowth], ["outreach", "Partner outreach", AdminOutreach]];

export default function Admin() {
  return (
    <div>
      <PageHeader eyebrow="Administration" title="Admin console" />
      <Tabs defaultValue="overview">
        <TabsList className="mb-6 flex h-auto flex-wrap justify-start gap-1 bg-white p-1">
          {TABS.map(([k, t]) => <TabsTrigger key={k} value={k} data-testid={`admin-tab-${k}`}>{t}</TabsTrigger>)}
        </TabsList>
        {TABS.map(([k, , C]) => <TabsContent key={k} value={k}><C /></TabsContent>)}
      </Tabs>
    </div>
  );
}
